import './HGlobalFooter.scss';
import Vue from 'vue';
import * as tsx from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import { HBtn } from '../HBtn';
import { HAllBrandsNavigation } from '~/components';
import { calculateAnniversary } from '~/utils/date';

export interface HGlobalFooterProps {}
export interface HGlobalFooterEmits {}
export interface HGlobalFooterScopedSlots {}

@Component<HGlobalFooterRef>({
  name: 'HGlobalFooter',
  render() {
    return (
      <footer staticClass="h-globalFooter">
        {/* ナビゲーション */}
        <div staticClass="h-globalFooter__inner">
          <HAllBrandsNavigation staticClass="h-globalFooter__brands" />

          <div staticClass="h-globalFooter__buttonArea">
            <HBtn
              staticClass="h-globalFooter__buttonArea__button"
              href={this.crossSearchUrl}>
              {this.$i18n.t('name.roomFinder')}
            </HBtn>
          </div>

          <div staticClass="h-globalFooter__copyrightArea">
            <div
              staticClass="h-globalFooter__copyrightArea__logoWrapper"
              // logo_en だけ小さく見えるので個別でwidthを設定している
              style={this.useEnglishLangLogo ? { maxWidth: '180px' } : {}}>
              <a
                href={this.$t('url.globalTop') as string}
                target="_blank"
                staticClass="h-globalFooter__copyrightArea__logo">
                <img
                  staticClass="h-globalFooter__copyrightArea__logo--years"
                  src={this.yearsLogo}
                  alt={
                    this.$t('label.companyAnniversary', {
                      year: this.companyAnniversary,
                    }) as string
                  }
                />
                <img
                  staticClass="h-globalFooter__copyrightArea__logo--hr"
                  src={this.hrLogo}
                  alt={this.$i18n.t('name.hr') as string}
                />
              </a>
            </div>
            <p staticClass="h-globalFooter__copyrightArea__copyrightWrapper">
              <small staticClass="h-globalFooter__copyrightArea__copyright">
                &copy; Hoshino Resorts Inc. All Rights Reserved.
              </small>
            </p>
          </div>
        </div>
      </footer>
    );
  },
})
export class HGlobalFooterRef extends Vue implements HGlobalFooterProps {
  /** 星野リゾートロゴの画像URL */
  get hrLogo() {
    return `${this.$res.img(
      `/common/logo-hr-${this.$language.current}_wh.svg`,
    )}`;
  }

  /** 横断検索のURL */
  get crossSearchUrl() {
    return this.$language.crossSearchUrl();
  }

  /**
   * 英語ロゴを使ってるかどうか
   *
   * * logo_en だけ小さく見えるので個別でwidthを設定している
   */
  get useEnglishLangLogo() {
    return this.$language.current === 'en' || this.$language.current === 'ko';
  }

  /**
   * 周年表示のロゴを取得
   * @memo きっとこれで周年表示が自動で切り替わってくれるはず...
   */
  get yearsLogo() {
    return this.$language.current === 'ja'
      ? `${this.$res.img(`/common/${this.companyAnniversary}-ja.svg`)}`
      : `${this.$res.img(`/common/${this.companyAnniversary}-en.svg`)}`;
  }

  /** 会社の設立年数を取得 */
  get companyAnniversary() {
    return calculateAnniversary(this.$env.renderingDateTime);
  }
}

export const HGlobalFooter = tsx
  .ofType<HGlobalFooterProps, HGlobalFooterEmits, HGlobalFooterScopedSlots>()
  .convert(HGlobalFooterRef);
